module.exports = __webpack_public_path__ + "img/XLogo.243bf8d3.svg";